module.exports = __webpack_public_path__ + "media/promo/lum2021/images/3rdm-ace5dd29eb5d9212532b087303251332.jpg";